import React from 'react'
import PropTypes from 'prop-types'

import { ResourceDetailsBlock } from '../../ProjectDescription.styles'

function GroundwaterDescription({ safeYield, totalExtraction, balance, lang }) {
  return (
    <>
      {safeYield && (
        <ResourceDetailsBlock>
          <div className="label">
            {lang === 'en'
              ? `Safe Yeild (MCM/year)`
              : `الحد الآمن للاستخراج (مليون م٣ في السنة)`}
          </div>
          <div className="value">{safeYield}</div>
        </ResourceDetailsBlock>
      )}
      {totalExtraction && (
        <ResourceDetailsBlock>
          <div className="label">
            {lang === 'en'
              ? `Total Extraction (MCM/year)`
              : `إجمالي الاستخراج (مليون م٣ في السنة)`}
          </div>
          <div className="value">{totalExtraction}</div>
        </ResourceDetailsBlock>
      )}
      {balance && (
        <ResourceDetailsBlock>
          <div className="label">
            {lang === 'en'
              ? `Balance (MCM/year)`
              : `الميزان (مليون م٣ في السنة)`}
          </div>
          <div className="value">{balance}</div>
        </ResourceDetailsBlock>
      )}
    </>
  )
}

GroundwaterDescription.propTypes = {
  id: PropTypes.string,
  safeYield: PropTypes.string,
  totalExtraction: PropTypes.string,
  balance: PropTypes.string,
  lang: PropTypes.string
}

export default GroundwaterDescription
